import React, { Component } from "react";

import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';

//material components
import Paper from '@material-ui/core/Paper';

//menuItems

class ModalVoiceSetting extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }


    //#region  Inner components

    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className="paperModalVoiceSetting" square='false' color='secondary'>
                    <Grid id='external_id_modal' container justifyContent='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justifyContent='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justifyContent='center' alignItems='center'>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '80px' }} justifyContent='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10}>
                        <Grid item container direction='row-reverse'>
                            <Grid item container className="VoiceSettingModalButtonYes skybluebtn-engage alingCenter">
                                <Grid id='sync_community_btn' item container className="alingCenter" onClick={() => this.props.SyncCLCommunity()}>
                                    Yes, Sync Community
                                </Grid>
                            </Grid>
                            <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                                <Grid id='close_community_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                    No, Cancel
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
        );
    };

    RenderMessageContainer = () => {

        return (
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="VoiceSubTitleModal">
                        <Grid>This sync will be send all the residents in the community to a community in the Connect Living eCMS.</Grid>
                        <Grid>Do you want to sync the community with Connect Living?</Grid>
                    </Grid>
                </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
            </Grid>
        );
    }
    //#endregion

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {

    return {
    }
}


ModalVoiceSetting = reduxForm({
    form: 'ModalVoiceSettingForm',
    enableReinitialize: true,
})(ModalVoiceSetting);

export default connect(mapStateToProps, {})(ModalVoiceSetting);

